module.exports = __webpack_public_path__ + "img/DanielCarneiro.86102d0e.png";